import React from 'react'
import { AchReport } from './achReport'

export const AchReportAPI = () => {
  return (
    <AchReport />
  )
}
